/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReferralDocumentExportRequestDocumentsInner
 */
export interface CreateReferralDocumentExportRequestDocumentsInner {
    /**
     * 
     */
    relation_type: CreateReferralDocumentExportRequestDocumentsInnerRelationTypeEnum;
    /**
     * 
     */
    relation_id: string;
}


/**
 * @export
 */
export const CreateReferralDocumentExportRequestDocumentsInnerRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type CreateReferralDocumentExportRequestDocumentsInnerRelationTypeEnum = typeof CreateReferralDocumentExportRequestDocumentsInnerRelationTypeEnum[keyof typeof CreateReferralDocumentExportRequestDocumentsInnerRelationTypeEnum];


/**
 * Check if a given object implements the CreateReferralDocumentExportRequestDocumentsInner interface.
 */
export function instanceOfCreateReferralDocumentExportRequestDocumentsInner(value: object): value is CreateReferralDocumentExportRequestDocumentsInner {
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    if (!('relation_id' in value) || value['relation_id'] === undefined) return false;
    return true;
}

export function CreateReferralDocumentExportRequestDocumentsInnerFromJSON(json: any): CreateReferralDocumentExportRequestDocumentsInner {
    return CreateReferralDocumentExportRequestDocumentsInnerFromJSONTyped(json, false);
}

export function CreateReferralDocumentExportRequestDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralDocumentExportRequestDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'relation_type': json['relation_type'],
        'relation_id': json['relation_id'],
    };
}

export function CreateReferralDocumentExportRequestDocumentsInnerToJSON(json: any): CreateReferralDocumentExportRequestDocumentsInner {
    return CreateReferralDocumentExportRequestDocumentsInnerToJSONTyped(json, false);
}

export function CreateReferralDocumentExportRequestDocumentsInnerToJSONTyped(value?: CreateReferralDocumentExportRequestDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
    };
}

